module.exports = __webpack_public_path__ + "static/27-0379200c22974f57fca6b047a1fffff2.jpg";